import i from './trucking.container';

export default i;
